<template lang="pug">
  .container
    .columns
      .column.is-8
        .field
          label.label Carga de Efectivale
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="cargaSel" :disabled="isDisabled")
                  option(v-for="c in cargas" :key="c.id" :value="c") {{ c.fecha }} | {{ c.tarjeta_numero }} | {{ c.comercio }} | {{ c.cargo | currency}}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-4(v-show="Object.keys(cargaSel).length > 0")
        .notification
          b  Datos de la carga de Efectivale:
          .columns
            .column
              span.tag 
                b Fecha:
              br
              span.tag 
                b Comercio:
              br
              span.tag 
                b Tarjeta:
              br
              span.tag 
                b Cantidad:
            .column
              span.tag.is-black 
                b {{ cargaSel.fecha}} 
              br
              span.tag.is-dark 
                b {{ cargaSel.comercio}} 
              br
              span.tag.is-dark 
                b {{ cargaSel.tarjeta_numero }} | {{ cargaSel.tarjeta_nombre }} 
              br
              span.tag.is-black 
                b {{ cargaSel.cargo | currency }} 
    .columns.is-vcentered
      .column.is-4
        .field
          label.label Usuarios
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="usuarioSel" :disabled="isDisabled")
                  option(v-for="user in usuarios" :key="user.id" :value="user") {{ user.nombre }}
              .icon.is-small.is-left
                i.far.fa-user
      .column.is-4
        .field
          label.label Vehículo
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="vehiculoSel" :disabled="isDisabled" v-show="!otroVehiculo")
                  option(v-for="car in vehiculos" :key="car.id" :value="car") {{ car.marca }} - {{ car.modelo }}
                select(v-model="vehiculoSel" :disabled="isDisabled" v-show="otroVehiculo")
                  option(v-for="car in vehiculos" :key="car.id" :value="car") {{ car.marca }} - {{ car.modelo }} - {{ car.resguardo }}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-1
        .field
          input.is-checkradio.is-primary(type='checkbox'  id="checkOtro" v-model="otroVehiculo")
          label.is-size-6(for="checkOtro") Otro
    .columns
      .column.is-3
        .field
          label.label Km. Actual (Al recargar)
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='00.00',
                v-model="kmActual",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Carga en Litros
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='00.00',
                v-model="cargaL",
                :disabled="isDisabled"
              )
      .column.is-6
        .field
          label.label Observación
            .control
              textarea.textarea.is-primary(placeholder="Observaciones" v-model="observacion" :disabled="isDisabled" rows="2")
    .columns
      Attachment(v-show="verDrop_DragBox" @sendImage="sendImage")
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .column.is-12
        .notification
          .field.is-grouped.is-grouped-multiline
            .control(v-for="datosF in datosFaltantes")
              .tags
                span.tag.is-danger.is-light {{ datosF }}
    .columns
      .column.is-offset-4.is-4
        a.button.is-black.is-rounded.is-block(@click="checkForm")
          | Guardar Salida
</template>

<script>
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import Attachment from './Attachment.vue'
  import moment from 'moment'
  import InventarioServices from '../../../services/inventario/inventario'
  export default {
    name: 'FormSalida',
    components: { flatPickr, Attachment },
    props: {
      usuarios: {
        type: Array,
        default: []
      },
      cargas: {
        type: Array,
        default: []
      },
      vehiculos: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        cargaSel: {},
        vehiculoSel: {},
        usuarioSel: {},
        cargaP: null,
        cargaL: null,
        kmActual: null,
        observacion: null,
        ticket: null,
        otroVehiculo: false,
        isDisabled: false,
        datosFaltantes: [],
        verDrop_DragBox: false,
        fechaSalida: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
      }
    },
    watch: {
      usuarioSel() {
        this.$emit('selectUser', this.usuarioSel)
      },
      kmActual () {
        this.checkKms()
      },
      otroVehiculo () {
        this.$emit('otroVehiculo', this.otroVehiculo)
      },
      cargaSel () {
        this.fechaSalida = moment(this.cargaSel.fecha).format('YYYY-MM-DD')
        this.cargaP = this.cargaSel.cargo
      }

    },
    methods: {
      checkForm() {
        this.datosFaltantes = []
        if (Object.keys(this.cargaSel).length > 0 && Object.keys(this.vehiculoSel).length > 0 && this.cargaP && this.cargaL && this.kmActual, this.ticket) {
          console.log('Datos completos')
          this.saveSalida()
        } else {
          console.log('Datos Incompletos')
          if ( Object.keys(this.vehiculoSel).length == 0 ) {
            this.datosFaltantes.push('el Vehículo es necesario.')
          }
          if ( Object.keys(this.cargaSel).length == 0 ) {
            this.datosFaltantes.push('La Tarjeta es necesaria.')
          }
          if (!this.cargaP) {
            this.datosFaltantes.push('La Carga en Pesos es necesario.')
          }
          if (!this.cargaL) {
            this.datosFaltantes.push('La Carga en Litros es necesario.')
          }
          if (!this.kmActual) {
            this.datosFaltantes.push('El Km. actual es necesario.')
          }
          if (!this.ticket) {
            this.datosFaltantes.push('El ticket es necesario.')
          }
        }
      },
      saveSalida() {
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let myObj = {
          fechaReg: fechaReg,
          fechaSalida: this.fechaSalida,
          idV: this.vehiculoSel.id,
          veh: `${this.vehiculoSel.marca}-${this.vehiculoSel.modelo}`,
          idT: this.cargaSel.id_articulo,
          noT: this.cargaSel.tarjeta_numero,
          cargaP: this.cargaP,
          cargaL: this.cargaL,
          kmActual: this.kmActual,
          observacion: this.observacion,
          ticket: this.ticket
        }
        this.$emit('saveForm', myObj)
      },
      // obtenerKmInicial () {
      //   InventarioServices.getKmInicio(this.vehiculoSel.id)
      //     .then((data)=> {
      //       if(data.length == 0) {
      //         this.kmInicial = 0
      //       } else {
      //         this.kmInicial = data[0].km_inicio
      //       }
      //     }) 
      //     .catch((e)=> console.log(e))
      // },
      checkKms() {
        if (isNaN(this.kmActual)) {
          this.kmActual = ''
          this.verDrop_DragBox = false
        } else {
          if (this.kmActual) {
            this.kmRecorrdidos = parseFloat(this.kmActual) - parseFloat(this.kmInicial)
            if (this.kmRecorrdidos < 0) {
              this.kmRecorrdidos = 0
            }
            this.consumo = parseFloat(parseFloat(this.kmRecorrdidos) / parseFloat(this.cargaL)).toFixed(2)
            if (parseFloat(this.consumo) > 10 ) {
              this.calidad = 'Bueno'
            } else {
              this.calidad = 'Malo'
            }
            this.verDrop_DragBox = true
          }
        }
      },
      sendImage(imagen) {
        if (imagen) {
          this.ticket = imagen
        } else {
          this.ticket = null
        }
      }
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/FormSalida.vue